import type { ColumnDef } from '@tanstack/react-table';

import { type GetCategoriesQuery, CategoryState } from 'data/__generated__';
import { textColumn, multiSelectColumn, booleanColumn, numberColumn } from 'components/DataTable';

import { TotemImage } from 'components/TotemImage';
import { StatusTag } from 'pages/Categories/components/StatusTag';

export type CategoryRow = GetCategoriesQuery['categories'][number];

export type CategoryFilterInput = {
    searchValue: string;
    state: CategoryState[];
    isTitreRestaurantAllowed: boolean;
    shouldShowSubcategories: boolean;
};

export const categoriesColumns: ColumnDef<CategoryRow, unknown>[] = [
    textColumn<CategoryRow, CategoryFilterInput>({
        accessorKey: 'imageUrl',
        header: 'Icone',
        defaultVisible: true,
        cell: ({ row }) => <TotemImage src={row.original.imageUrl || ''} alt={row.original.title} size={50} />,
    }),
    textColumn<CategoryRow, CategoryFilterInput>({
        accessorKey: 'title',
        header: 'Nom',
        defaultVisible: true,
    }),
    textColumn<CategoryRow, CategoryFilterInput>({
        accessorKey: '_id',
        header: 'Identifiant unique',
        defaultVisible: false,
    }),
    numberColumn<CategoryRow, CategoryFilterInput>({
        accessorKey: 'indexDisplay',
        header: "Index d'affichage",
        defaultVisible: true,
    }),
    booleanColumn<CategoryRow, CategoryFilterInput>({
        accessorKey: 'isTitreRestaurantAllowed',
        header: 'Titres Restaurant',
        filterKey: 'isTitreRestaurantAllowed',
        defaultVisible: true,
    }),
    booleanColumn<CategoryRow, CategoryFilterInput>({
        accessorKey: 'shouldShowSubcategories',
        header: 'Afficher sous-catégories',
        filterKey: 'shouldShowSubcategories',
        defaultVisible: true,
    }),
    multiSelectColumn<CategoryRow, CategoryFilterInput>({
        accessorKey: 'state',
        header: 'Statut',
        filterKey: 'state',
        defaultVisible: true,
        options: Object.values(CategoryState).map((state) => ({ value: state, label: state })),
        renderOption: (option) => <StatusTag state={option.value as CategoryState} />,
        cell: ({ row }) => <StatusTag state={row.original.state} />,
    }),
];
